import React, { FC, useEffect } from "react";

import styled from "styled-components";

import { useMediaDisplayer } from "@/shared/hooks";

const DOCUMENT_PREVIEW_ELEMENT_ID = "documentPreview";

const StyledDocumentPreview = styled.div`
    flex: 1;
    margin-bottom: 8px;
`;

type DocumentPreviewProps = {
    url: string;
    title: string;
    type?: string;
};

const DocumentPreview: FC<DocumentPreviewProps> = ({ url, title, type = "pdf" }) => {
    const { displaySizedMode } = useMediaDisplayer();

    useEffect(() => {
        displaySizedMode({
            title,
            type,
            url,
            elementId: DOCUMENT_PREVIEW_ELEMENT_ID,
        });
    }, []);

    return <StyledDocumentPreview style={{ flex: "1", marginBottom: "8px" }} id={DOCUMENT_PREVIEW_ELEMENT_ID} />;
};

export default DocumentPreview;
